import { ApiContentSection, ApiSectionType } from '@storefronts/common-types'
import { getTypographyRoleStyle } from '../../../style/typography'
import { SectionContainer, SectionTitle } from './Shared'
import { scaledFontSize, ScrollingLayout } from '../../../style/scrollingLayout'

type BodySection = Extract<
    ApiContentSection,
    { type: ApiSectionType.BODY_TEXT }
>

interface BodyTextProps {
    section: BodySection
}

export const BodyText: React.FC<BodyTextProps> = ({ section }) => {
    return (
        <SectionContainer maxContentWidth={ScrollingLayout.PROSE_MAX_WIDTH}>
            {section.sectionTitle && (
                <SectionTitle>{section.sectionTitle}</SectionTitle>
            )}
            <div style={{ textAlign: 'left' }}>
                <span
                    style={{
                        ...getTypographyRoleStyle('bodyText', {
                            fontWeight: 400,
                            lineHeight: 1.3,
                        }),
                        fontSize: scaledFontSize(16),
                    }}
                >
                    {section.text}
                </span>
            </div>
        </SectionContainer>
    )
}
